import { ApiName } from './ApiName';

export const areMocksEnabled: { [key in ApiName]: boolean } = {
	[ApiName.AddonFeatures]: false,
	[ApiName.Addons]: false,
	[ApiName.Annotations]: false,
	[ApiName.ARM]: false,
	[ApiName.AssessmentBranch]: false,
	[ApiName.AssessmentBranchExperiments]: false,
	[ApiName.Assessments]: false,
	[ApiName.AzureMaps]: false,
	[ApiName.Blueprints]: false,
	[ApiName.CaseManagement]: false,
	[ApiName.CustomActions]: false,
	[ApiName.CustomActionsLoad]: false,
	[ApiName.Dataview]: false,
	[ApiName.Entitlements]: false,
	[ApiName.Environments]: false,
	[ApiName.EventTracing]: false,
	[ApiName.ExternalAssessments]: false,
	[ApiName.ExternalCall]: false,
	[ApiName.FQL]: false,
	[ApiName.GDPR]: false,
	[ApiName.GlobalFunctions]: false,
	[ApiName.Header]: false,
	[ApiName.Hierarchy]: false,
	[ApiName.Lists]: false,
	[ApiName.Metrics]: false,
	[ApiName.MsGraph]: false,
	[ApiName.Notifications]: false,
	[ApiName.OptIn]: false,
	[ApiName.OverrideApplication]: false,
	[ApiName.PageTemplate]: false,
	[ApiName.PageTemplateData]: false,
	[ApiName.Permissions]: false,
	[ApiName.PowerBi]: false,
	[ApiName.ProvisioningV2]: false,
	[ApiName.Rbac]: false,
	[ApiName.RbacGql]: false,
	[ApiName.Redirect]: false,
	[ApiName.RoutingRules]: false,
	[ApiName.Rules]: false,
	[ApiName.Schema]: false,
	[ApiName.Search]: false,
	[ApiName.SupportActions]: false,
	[ApiName.Tenants]: false,
	[ApiName.UserPreferences]: false,
	[ApiName.Velocity]: false,
};
